import type { ContractFixedFeesColumns } from '../contract-fixed-fees-types/contract-fixed-fees-columns';

export const CONTRACT_PAGE_FIXED_FEES_COLUMNS_KEYS = Object.freeze({
  PRODUCT_NAME: 'productName',
  PRICING_TYPE: 'pricingType',
  AMOUNT: 'amount',
  DISCOUNT: 'discount',
  QUANTITY: 'quantity',
  BILLING_INTERVAL: 'billingInterval',
  PAYMENT_TERM: 'paymentTerm',
  START_DATE: 'startDate',
  INSTALLMENTS: 'installments',
  PRO_RATE: 'proRate',
  PRICE_PER_UNIT: 'pricePerUnit',
  ERP: 'erp',
  ANROK_ID: 'anrokId',
  MARKETPLACE_PRODUCT_ID: 'marketplaceProductId',
  MARKETPLACE_DIMENSION: 'marketplaceDimension',
  SCHEDULE_START_DATE: 'scheduleStartDate',
  SCHEDULE_END_DATE: 'scheduleEndDate',
} satisfies Record<string, keyof ContractFixedFeesColumns>);
